import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import { useEffect, useRef, useState } from 'react'
import emailjs from '@emailjs/browser';

const Contact = () => {

    const [letterClass, setLetterClass] = useState('text-animate')
    const refForm = useRef()

    useEffect(() => {
        let timeout = setTimeout(() => {
            setLetterClass("text-animate-hover");
        }, 3000);
       
        return () => {
            clearTimeout(timeout);
        };
    }, []);

    const sendEmail = (e) => {
        e.preventDefault()

        emailjs
        .sendForm('service_ghwh1qb', 'template_krd7wdm', refForm.current, {
            publicKey: 'nmDrxFXyI6rLColhv',
          })
        .then(
            () => {
                alert('Message successfully sent! Redirecting...')
                window.location.replace('/')
            },
            (error) => {
                alert('Message send failure! Please try again...')
            }
        )
    }

    return (
        <div className='container contact-page'>
            <div className='text-zone'>
                <h1 className='contact-h1'>
                    <AnimatedLetters 
                        letterClass={letterClass}
                        strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
                        idx={15}
                    />
                </h1>
                <p>I am currently looking for employment, with a preference for internships and part-time jobs. If you would like to get in touch with me, please do not hesitate to use the form below.</p>
                <div className='contact-form'>
                    <form ref={refForm} onSubmit={sendEmail}>
                        <ul>
                            <li className='half'>
                                <input type='text' name='name' placeholder='Name' required />
                            </li>
                            <li className='half'>
                                <input type='email' name='email' placeholder='Email' required />
                            </li>
                            <li>
                                <input type='text' name='subject' placeholder='Subject' required/>
                            </li>
                            <li>
                                <textarea name='message' placeholder='Message' required></textarea>
                            </li>
                            <li>
                                <input type='submit' className='flat-button send-button' value='SEND'/>
                            </li>
                        </ul>
                    </form>
                </div>
            </div>
        </div>
    )

}

export default Contact